import {Dispatch, SetStateAction} from 'react'
import {MetadataQuery} from '../backend/model'

export const backendJavaMaxLong = 9223372036854775807n
const EXECUTION_ID_LENGTH = 36
const integerRegex = /^\d+$/

export function isValidNumericId(id: string): boolean {
    if (integerRegex.test(id)) {
        const convertedId = BigInt(id)
        return !!id && convertedId > 0n && convertedId <= backendJavaMaxLong
    } else return false
}

export function isValidAcId(id: string): boolean {
    return !!id && id.length === 36
}

export function isValidFnsku(fnsku: string): boolean {
    return !!fnsku && fnsku.length === 10
}

export function isValidExecutionId(executionId: string): boolean {
    return !!executionId && executionId.length === EXECUTION_ID_LENGTH
}

export function isNotBlankOrEmpty(value: string): boolean {
    return value.trim() !== ''
}

export function isValidJSON(value: string): boolean {
    try {
        return !Array.isArray(JSON.parse(value))
    } catch (err: any) {
        return false
    }
}

export function isValidArray(value: string): boolean {
    try {
        return Array.isArray(JSON.parse(value))
    } catch (err: any) {
        return false
    }
}

export function exists(value: any): boolean {
    return !!value
}

export function maxLength(length: number): (value: string) => boolean {
    return (value: string) => value.length <= length
}

interface FormValidator<S> {
    test: (value: S) => boolean;
    message: string;
}

export function validate<S>(value: S, validators: Array<FormValidator<S>>, setErrorMessage: Dispatch<SetStateAction<string>>): boolean {
    for (const validator of validators) {
        if (!validator.test(value)) {
            setErrorMessage(validator.message)
            return false
        }
    }

    setErrorMessage('')
    return true
}

export function isNotEmptyQuery(query: MetadataQuery): boolean {
    return Object.values(query).some(value => value !== undefined)
}
